import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Stack, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import { userSignIn } from '../api/user.api';

const SigninPage = () => {
    const navigate = useNavigate();

    const [isRequest, setIsRequest] = useState(false);

    const form = useFormik({
        initialValues: {
            username: '',
            password: '',
        },
        validationSchema: yup.object({
            username: yup.string().required('Username is required').min(4).max(20),
            password: yup.string().required('Password is requried').min(6),
        }),
        onSubmit: (values) => onSignIn(values),
    });

    const onSignIn = async ({ username, password }) => {
        if (isRequest) return;
        setIsRequest(true);

        const res = await userSignIn({ username, password });
        console.log("user siginin res:", res);
        setIsRequest(false);

        if (res.success) {
            localStorage.setItem('tkn', res.data.token);
            navigate('/');
        }else{
            toast.error(res.msg);
        }

    };

    return (
        <Box component="form" noValidate onSubmit={form.handleSubmit}>
            <Stack spacing={3}>
                <TextField
                    fullWidth
                    placeholder="Username"
                    name="username"
                    value={form.values.username}
                    onChange={form.handleChange}
                    error={form.touched.username && form.errors.username !== undefined}
                    helperText={form.touched.username && form.errors.username}
                />
                <TextField
                    fullWidth
                    type="password"
                    placeholder="Password"
                    name="password"
                    value={form.values.password}
                    onChange={form.handleChange}
                    error={form.touched.password && form.errors.password !== undefined}
                    helperText={form.touched.password && form.errors.password}
                />
                <LoadingButton type="submit" size="large" variant="contained" loading={isRequest} color="success">
                    signin
                </LoadingButton>
            </Stack>
        </Box>
    );
};

export default SigninPage;
